// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';

// export const PrivateRoute = ({ children }) => {
//   const { accessToken } = useAuth();
//   return accessToken ? children : <Navigate to="/login" />;
// };

// components/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loading from "../components/Loading";

export const PrivateRoute = ({ children, allowedRoles }) => {
  const { accessToken, user, loading } = useAuth();

  if (loading) return <Loading fullscreen={true} />;

  if (!accessToken) return <Navigate to="/login" replace />;

  // If role is required and doesn't match
  if (
    allowedRoles &&
    user &&
    !allowedRoles.includes(user.userRole.value.toLocaleLowerCase())
  ) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};
